﻿import gsap from 'gsap';

export default function animateCards() {
    const card_timeline = gsap.timeline();
    card_timeline.from('.animation-card', {
        duration: 1, ease: "power2.inOut", y: 50, opacity: 0, stagger: {
            amount: 1.5
        }
    });
}